import routePath from '@src/lib/routePath'

const base = `/retailer/leads/:retailerAccountSlug/all`

const leadsPaths = {
  root: routePath(`${base}` as const),
  index: routePath(`${base}/:activeTab?` as const),
  import: routePath(`${base}/import/:importId` as const),
}

export default leadsPaths
